<template>
  <div :class="$style.wrap">
    <p>更多活动资讯请关注</p>
    <div :class="[$style.qrc, 'van-hairline--surround']">
      <img v-lazy="wechat" />
    </div>
    <base-link-list :list="links" justify="space-around" :class="$style.link" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BaseLinkList from "../components/BaseLinkList";

export default {
  name: "TheContact",
  components: {
    [BaseLinkList.name]: BaseLinkList
  },
  computed: {
    ...mapGetters(["hrLink", "weibo", "tel", "wechat"]),
    links() {
      return [
        { name: "hr", ...this.hrLink },
        { name: "sina", ...this.weibo }
      ];
    }
  }
};
</script>

<style module lang="less">
@contact-background-color: #d1d4da;

.wrap {
  margin-top: 4em;
  padding: 2em 0;
  background-color: @contact-background-color;
  text-align: center;

  p:first-child {
    font-size: 0.38rem;
  }
}

.qrc {
  .flex-center();
  .size(3.58rem);
  position: relative;
  margin: 1.5em auto 0;

  img {
    .size(3.22rem);
  }

  &::before {
    .justify-center();
    content: "长按二维码关注极致游戏";
    z-index: 1;
    position: absolute;
    bottom: -0.5em;
    padding: 0 1em;
    background-color: @contact-background-color;
    font-size: @font-size-xs;
    white-space: nowrap;
  }

  &::after {
    border-color: #b1b4b9;
  }
}

.link {
  margin: 2em 1.2rem 0;

  :global {
    .van-button {
      display: inline-flex;
      align-items: center;
      padding: 0;
      border: 0;
      background-color: transparent;
      font-size: @font-size-lg;

      &::after {
        .size(0.55rem);
        content: "";
        display: inline-block;
        margin-left: 0.25em;
        background: url("../images/icons.png") no-repeat;
        background-size: 200% 200%;
      }
    }

    .hr .van-button::after {
      background-position: 0 0;
    }

    .sina .van-button::after {
      background-position: right 0;
    }

    .tel .van-button::after {
      background-position: 0 bottom;
    }
  }
}
</style>
